import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import InputLabel from 'components/generics/InputLabel/InputLabel';
import Select from 'components/generics/Select/Select';
import { Loader } from 'components/generics/Loader/Loader';
import CumulativeStageChart from 'components/pages/Stats/FlightTimePerStages/CumulativeStageChart';
import { getFlightTimePerStages } from 'services/API/Stats';

import './FlightTimePerStagesStats.style.scss';

const FlightTimePerStagesStats = () => {
  const [loading, setLoading] = useState(true);
  const [aircrafts, setAircrafts] = useState([]);
  const [stages, setStages] = useState([]);
  const [series, setSeries] = useState({});
  const [selectedAircraftId, setSelectedAircraftId] = useState(0);

  useEffect(() => {
    getFlightTimePerStages()
      .then(res => {
        setAircrafts(res.data.aircrafts);
        setStages(res.data.stages);
        setSeries(res.data.series);
        if (res.data.aircrafts.length > 0) {
          setSelectedAircraftId(res.data.aircrafts[0].id);
        }
        setLoading(false);
      })
      .catch(err => {
        toast.error(err.message);
        setLoading(false);
      });
  }, []);

  const selectedAircraft = aircrafts.find(aircraft => aircraft.id === selectedAircraftId);
  const points = series[selectedAircraftId] || [];

  return (
    <div id="FlightTimePerStagesStats">
      {loading ? (
        <Loader />
      ) : (
        <div className="statsSection" id="chart">
          <div className="header">
            <InputLabel label="Aircraft" name="aircraft">
              <Select
                name="aircraft"
                options={aircrafts}
                itemValue="id"
                itemLabel="reg"
                className="primary"
                value={selectedAircraftId}
                onChange={value => setSelectedAircraftId(+value)}
                disabled={aircrafts.length === 0}
              />
            </InputLabel>
            <h3>Cumulative flight time per stages</h3>
          </div>

          {aircrafts.length === 0 ? (
            <p className="empty">Aucun vol lié à un stage pour le moment.</p>
          ) : (
            <>
              {selectedAircraft && (
                <p className="aircraftInfo">
                  {selectedAircraft.reg} — contrat : {selectedAircraft.contractPlannedHours} h
                </p>
              )}
              <div className="graphContainer">
                <CumulativeStageChart stages={stages} points={points} />
              </div>
              <div className="legend">
                <span>
                  <i style={{ backgroundColor: '#03A9F4' }} /> Planned hours
                </span>
                <span>
                  <i style={{ backgroundColor: '#016593' }} /> TLB hours
                </span>
                <span>
                  <i style={{ backgroundColor: '#4ec6fd' }} /> Contracted hours
                </span>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FlightTimePerStagesStats;
